{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40084-3",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "5ce64381-c0fe-464f-a2e7-07c671a1b7b4",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
      "nodeId": "ns=1;i=6661",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40084-3.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "478cdc6d-5d2e-4889-84fa-3145b95b3697",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
      "nodeId": "ns=1;i=6682",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": true
    },
    "colorValues": {
      "Executing": "#00ff00",
      "NotAvailable": "#c8c8c8",
      "OutOfService": "#ff0000",
      "NotExecuting": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "2b4c6e72-56ce-4f03-bb16-327170310e76",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6656",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "4e6be6e5-ff9b-45c6-b047-61425eca073c",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6652",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "5ce64381-c0fe-464f-a2e7-07c671a1b7b4",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6661",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "cd7e134e-f83d-4892-9dbf-4b1736f731d8",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6653",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Actual Temperature",
              "valueVariable": {
                "id": "654cde44-0d23-491e-af60-a1b81f9c2b2a",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
                "nodeId": "ns=1;i=6115",
                "displayName": "ActualValue",
                "variablePath": "ActualValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ],
          "placeholderObject": "TemperatureZones.TemperatureZone_<Nr>.[PLACEHOLDER]",
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
            "nodeId": "ns=1;i=1016",
            "displayName": "ExtrusionTemperatureZoneType",
            "typeDefinition": "nsu=http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/;i=1016",
            "subTypes": []
          },
          "titleVariable": {
            "id": "48b17035-68ff-4c03-b3fa-4d0643210dfd",
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/Extrusion_v2/GeneralTypes/",
            "nodeId": "ns=1;i=6110",
            "displayName": "Id",
            "variablePath": "Id",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
